module.exports = __webpack_public_path__ + "static/media/GPX.8eb6ed7c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/GPX.svg
// module id = 537
// module chunks = 0